// @ts-nocheck
import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import StickyNoteBlockData from '../../../Models/Content/StickyNoteBlockData';
import './stickyNoteBlock.scss';
import StickyNoteMain from './StickyNoteMain';

export default class StickyNoteBlock extends EpiComponent<StickyNoteBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <StickyNoteMain iContent={this.props.data} context={this.getContext()} />;
  }
}
